<template>
	<div class="thankyou">
		<div class="container"> 
            <h6>{{ this.$t('Submission Confirmation Screen') }}</h6>
        </div>
	</div>
</template>

<script>

export default {
    name: "thankyou"
};
</script>

<style>
	.thankyou{
		margin-top: 20%;
	}
</style>
